import {changeEvent, clickEvent, customDocumentEvent} from "../../../webpack/modules/events";
import {showPopup} from "../../../webpack/modules-optimized/up-selling-personalized-text";
import {hideModal} from "../../../webpack/modules-optimized/modal";
import {
    getImageSliders,
    goToSliderNumber,
    initImageSliders, updatePriceElements,
    updateTotalPages
} from "../../../webpack/modules-optimized/product-page";
import {post} from "../../../webpack/modules/ajax";
import {showModal} from "../../../webpack/modules-optimized/modal";
import {convertSvgToBase64} from "../../../webpack/modules-optimized/product";

changeEvent('#product-page input#checkbox-up-selling-personalized-text', false, function (checkbox) {
    if (checkbox.checked) {
        checkbox.checked = false;
        showPopup();
    } else {
        checkbox.value = '';
        checkbox.dataset.width = '';
        checkbox.dataset.height = '';
        checkbox.dataset.text = '';
        checkbox.dataset.font = '';
        checkbox.dataset.color = '';
        checkbox.dataset.mirrored = '';
        checkbox.dataset.rightToLeft = '';
        checkbox.dataset.svg = '';
        checkbox.dataset.price = '';
        document.querySelector('.up-selling-personalized-text .added-personalized-text').classList.add('d-none');
        document.querySelector('.up-selling-personalized-text .edit-personalized-text').classList.add('d-none');
        document.querySelector('.up-selling-personalized-text .no-added-personalized-text').classList.remove('d-none');
        removePersonalizedTextSlide();
    }
});

clickEvent('#product-page .edit-personalized-text', false, function() {
    showModal('personalized-text-pop-up');
});

customDocumentEvent('upSellingPersonalizedTextAddToCart', function (event) {
    let container = document.getElementById('product-page');
    let checkbox = document.querySelector('#product-page input#checkbox-up-selling-personalized-text');

    checkbox.checked = true;
    checkbox.value = event.detail.productId;
    checkbox.dataset.width = event.detail.width;
    checkbox.dataset.height = event.detail.height;
    checkbox.dataset.text = event.detail.text;
    checkbox.dataset.font = event.detail.font;
    checkbox.dataset.color = event.detail.color;
    checkbox.dataset.mirrored = event.detail.mirrored;
    checkbox.dataset.rightToLeft = event.detail.rightToLeft;
    checkbox.dataset.price = event.detail.price;
    checkbox.dataset.fontFile = event.detail.fontFile;
    checkbox.dataset.colorHex = event.detail.colorHex;
    hideModal('personalized-text-pop-up');
    container.querySelector('.up-selling-personalized-text .personalized-text').innerHTML = event.detail.text;
    container.querySelector('.up-selling-personalized-text .price').innerHTML = event.detail.price;
    container.querySelector('.up-selling-personalized-text .no-added-personalized-text').classList.add('d-none');
    container.querySelector('.up-selling-personalized-text .added-personalized-text').classList.remove('d-none');
    container.querySelector('.up-selling-personalized-text .edit-personalized-text').classList.remove('d-none');

    updatePriceElements(container);
    removePersonalizedTextSlide();
    let generateText = {
        text: event.detail.text,
        fontFile: event.detail.fontFile,
        color: event.detail.colorHex,
        rightToLeft: event.detail.rightToLeft
    };
    addPersonalizedTextSlide(generateText, event.detail.mirrored);
});

function removePersonalizedTextSlide()
{
    let previewText = document.querySelector('.up-selling-personalized-text-preview');
    let imageSliders = getImageSliders();

    if (previewText) previewText.remove();
    imageSliders.forEach((imageSlider) => imageSlider.remove('.up-selling-personalized-text-preview'));
    updateTotalPages();
}

function addPersonalizedTextSlide(generateText, mirrored)
{
    let container = document.querySelector('#product-page');
    let defaultPrice = document.querySelector('.add-item-wish-list');
    let richCard = document.querySelector('script[type="application/ld+json"]');
    let productType = '-';
    let lastItem = document.querySelectorAll('.image-slider .splide__slide').length + 1;
    let exclusivePremium = document.getElementById('exclusivePremium').value;
    let isArProduct = document.getElementById('isArProduct').value;
    if (richCard) {
        let jsonld = JSON.parse(richCard.innerText);
        productType = (jsonld ? jsonld.category || '' : '').toLowerCase();
    }

    post(
        '/ajax/website/product/get-image-slider',
        {
            id: container.dataset.productId,
            price: defaultPrice.dataset.productPrice,
            mirrored : mirrored,
            generateText: generateText,
            exclusivePremium: exclusivePremium,
            isArProduct: isArProduct
        },
        function(response) {
            let image = container.querySelector('.image');
            image.innerHTML = response.view;
            initImageSliders(document.querySelectorAll('main.product .image .splide'), productType);
            updateTotalPages();
            window.lazyLoad.update();
            goToSliderNumber(lastItem);
        }
    );
}